import React from "react";
import "./MeetYourTherapist.css";

const MeetYourTherapist: React.FC = () => {
  return (
    <section id="meet-therapist" className="meet-therapist-section">
      <div className="meet-therapist-container">
        <h2 className="section-heading">Meet Your Therapist</h2>
        <div className="therapist-content">
          <div className="therapist-text">
            <p>
              Hi, I’m Arushi Suri, a Counselling Psychologist, dedicated to
              creating a calm and supportive space for your inner journey, where
              we can explore your inner landscapes; your thoughts, emotions and
              experiences, at a pace that feels comfortable for you.
            </p>
            <p>
              I hold a Bachelor’s in Applied Psychology and a Master’s in
              Counseling Psychology and have completed training in various
              modalities such as Acceptance and Commitment Therapy and Inner
              Child Work. I have worked in settings such as Hospital (Fortis
              Vasant Kunj), Employee Assistance Program and with private
              practitioners, supporting populations such as students, young
              adults, adults, geriatric population, corporate employees and
              parents.
            </p>
          </div>
          <div className="therapist-photo">
            {/* <div className="photo-placeholder"> */}
            <img
              src="/arushisuri.jpg"
              alt="Arushi Suri"
              className="therapist-photo-img"
              width={300}
              style={{ borderRadius: "10px" }}
            />
            {/* </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetYourTherapist;
